import { Component } from '@jky/component';
import { StandardEvents, CartLinesUpdateEvent } from '@shopify/events';
const MAX_VISIBLE_COUNT = 100;
export class JkyCartIconComponent extends Component {
  requiredRefs = ['cartBubble', 'cartBubbleCount'];
  get currentCartCount() {
    return parseInt(this.refs.cartBubbleCount.textContent ?? '0', 10);
  }
  set currentCartCount(value) {
    if (value === undefined || value === null) return;
    this.refs.cartBubbleCount.textContent = value < MAX_VISIBLE_COUNT ? String(value) : '99+';
  }
  connectedCallback() {
    super.connectedCallback();
    this.setCartIconAccessibility();
    this.onCartUpdate = this.onCartUpdate.bind(this);
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate);
  }

  setCartIconAccessibility() {
    const cartLinks = this.querySelectorAll('a');
    if (cartLinks.length) {
      cartLinks.forEach(cartLink => {
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.setAttribute('aria-label', 'cart');
        cartLink.classList.add("pointer-events-none");
        cartLink.addEventListener('click', (event) => {
          event.preventDefault();
        });
      });
    }
  }

  /**
   * 处理购物车更新事件
   * @param {CartLinesUpdateEvent} event - 购物车更新事件
   */
  onCartUpdate(event) {
    event.promise?.then(({ cart, detail }) => {
        const itemCount = cart?.totalQuantity ?? detail?.itemCount ?? 0;
        this.renderCartBubble(itemCount);
    })
    .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[jky-cart-icon] CartLinesUpdateEvent promise rejected:', error);
    });
  }
  /**
   * 更新购物车图标的计数
   * @param {number} itemCount - 购物车中的商品数量
   */
  async renderCartBubble(itemCount) {
    this.refs.cartBubble.classList.toggle('hidden', itemCount === 0);
    this.currentCartCount = itemCount;
  }
  openCart() {
    if(!document.querySelector('jky-cart')) return;
    document.querySelector('jky-cart').open?.();
  }
}

if (!customElements.get('jky-cart-icon')) {
  customElements.define('jky-cart-icon', JkyCartIconComponent);
}